import React from 'react';

const TxtBase = ({ children }) => {
    return (
        <u className='text-base text-primary-darkHighlight-s1l1 dark:text-primary-lightHighlight-s1l1'>
            {children}
        </u>
    );
};

export default TxtBase